import { FC, useRef } from "react";
import { useReactiveVar } from "@apollo/client";
import { ModelFileTypeEnum } from "../../../../../generated/graphql";
import { mobileAppModel } from "../../state";
import { IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { HiddenInput, HiddenInputLabel, ModalWithPhotoInput, PrimaryLink, UnderlayButton } from "../../../../shared/Style/Style";
import { CoordinatesContainer, MobileAppModalBundleName } from "../../../MobileAppModal.style";

export const MapCoordinates = () => { 
  const mapInput = useRef<HTMLInputElement | null>(null);
  const inputErrors = useReactiveVar(mobileAppModel.inputErrors);
  const isLoading = useReactiveVar(mobileAppModel.updateLoading);
  const model = useReactiveVar(mobileAppModel.model);

  if (!model) return null;

  const { id, address, lat, longitude, mapMarkerPhoto } = model;

    return (
      <>
        <ModalWithPhotoInput
          disabled={isLoading}
          label="Адрес"
          fullWidth
          error={inputErrors.address.error}
          value={address}
          onFocus={() =>
            mobileAppModel.setInputErrors("address", false)
          }
          onChange={({ target: { value } }) =>
            mobileAppModel.setCoordinates('address', value)
          }
        />
        
        <CoordinatesContainer>
          <ModalWithPhotoInput
            disabled={isLoading}
            label="Широта"
            error={inputErrors.lat.error}
            value={lat}
            onFocus={() =>
              mobileAppModel.setInputErrors("lat", false)
            }
            onChange={({ target: { value } }) =>
              mobileAppModel.setCoordinates('lat', value)
            }
          />

          <ModalWithPhotoInput
            disabled={isLoading}
            label="Долгота"
            error={inputErrors.longitude.error}
            value={longitude}
            onFocus={() =>
              mobileAppModel.setInputErrors("longitude",false)
            }
            onChange={({ target: { value } }) =>
              mobileAppModel.setCoordinates('longitude', value)
            }
          />
        </CoordinatesContainer>
        
        <CoordinatesContainer>
          <MobileAppModalBundleName>Метка на карте</MobileAppModalBundleName>
          
          {mapMarkerPhoto ? (
            <span>
              <PrimaryLink href={mapMarkerPhoto}>Метка на карте</PrimaryLink>
              <IconButton
                disabled={isLoading}
                onClick={() => mobileAppModel.deleteAppModelFiles(id, ModelFileTypeEnum.MapMarkerPhoto)}
              >
                <Delete color="secondary" />
              </IconButton>
            </span>) : (
              <HiddenInputLabel htmlFor="mapPhoto">
                <UnderlayButton>Прикрепить</UnderlayButton>
              </HiddenInputLabel>
            )
          }
        </CoordinatesContainer>

        <HiddenInput
          id="mapPhoto"
          type="file"
          accept="image/png, image/jpeg"
          ref={mapInput}
          disabled={isLoading}
          onFocus={() => (mapInput.current.value = "")}
          onChange={({ target: { files } }) => files[0] && mobileAppModel.updateMapMarker(id, files[0])}
        />
        
        </>
    );
};